import {API_URLS} from '@/const/urls';
import {http} from '@/helper/http';
import {botsUtil} from '@/modules/strategy/utils';

export const strategyApi = {
  marketplaceSummary() {
    return http.get(API_URLS.MARKETPLACE_SUMMARY, {});
  },
  marketplaceDropdownInfo(query) {
    if (botsUtil.isMockSpotBots()) {
      return Promise.resolve({
        code: 0,
        msg: 'OK',
        data: {
          symbolList: [],
          directionList: [],
          suggestedPeriodList: [],
          pnlRatioList: [],
        },
      });
    }
    const api = botsUtil.isSpotBots() ? API_URLS.SPOT_MARKETPLACE_DROPDOWN_INFO : API_URLS.MARKETPLACE_DROPDOWN_INFO;
    return http.get(api, {query});
  },
  marketplaceSearch(query) {
    if (botsUtil.isMockSpotBots()) {
      return Promise.resolve({code: 0, msg: 'OK', data: {totalCount: 0, page: 1, rows: []}});
    }
    const api = {
      CONTRACT_MARTIN: API_URLS.MARKETPLACE_MARTINGALE,
      CONTRACT_GRID: API_URLS.MARKETPLACE_SEARCH,
      SPOT_GRID: API_URLS.SPOT_MARKETPLACE_SEARCH,
    }[query.strategyType];
    return http.get(api, {query});
  },
  detailMain(query) {
    if (botsUtil.isMockSpotBots()) {
      return Promise.resolve({code: 0, msg: 'OK', data: null});
    }
    const api = botsUtil.isContractBots() ? API_URLS.STRATEGY_DETAIL_MAIN : API_URLS.SPOT_STRATEGY_DETAIL_MAIN;
    return http.get(api, {query});
  },
  martingaleDetailMain(query) {
    return http.get(API_URLS.MARTINGALE_DETAIL_MAIN, {query});
  },
  martingaleCycleHistoryList(query) {
    return http.get(API_URLS.MARTINGALE_CYCLE_HISTORY_LIST, {query});
  },
  martingaleDetailOrderList(query) {
    return http.get(API_URLS.MARTINGALE_DETAIL_ORDER_LIST, {query});
  },
  detailOrders(query) {
    const api = botsUtil.isContractBots() ? API_URLS.STRATEGY_ORDER_LIST : API_URLS.SPOT_STRATEGY_ORDER_LIST;
    return http.get(api, {query});
  },
  detailArbiSummary(query) {
    const api = botsUtil.isContractBots() ? API_URLS.STRATEGY_ARBI_SUMMARY : API_URLS.SPOT_STRATEGY_ARBI_SUMMARY;
    return http.get(api, {query});
  },
  getHistory(query) {
    const api = botsUtil.isContractBots() ? API_URLS.STRATEGY_ARBI_LIST : API_URLS.SPOT_STRATEGY_ARBI_LIST;
    return http.get(api, {query});
  },
  increaseBalance(params) {
    return http.post(API_URLS.STRATEGY_ADD_BALANCE, {params});
  },
  updateTpsl(params) {
    const api = botsUtil.isContractBots() ? API_URLS.STRATEGY_UPDATE_TPSL : API_URLS.SPOT_STRATEGY_UPDATE_TPSL;
    return http.post(api, {params});
  },
  martingaleAdjustTpSl(params) {
    return http.post(API_URLS.MARTINGALE_ADJUST_TP_SL, {params});
  },
  getOpenStrategy() {
    return http.get(API_URLS.STRATEGY_ALL_MY_OPEN, {});
  },
  signalDetail(query) {
    return http.get(API_URLS.SIGNAL_DETAIL_MAIN, {query});
  },
  signalOpenPos(query) {
    return http.get(API_URLS.SIGNAL_DETAIL_OPEN_POSITION, {query});
  },
  signalClosePos(query) {
    return http.get(API_URLS.SIGNAL_DETAIL_CLOSE_POSITION, {query});
  },
  signalOrderList(query) {
    return http.get(API_URLS.SIGNAL_DETAIL_ORDER_LIST, {query});
  },
  signalOrderRecord(query) {
    return http.get(API_URLS.SIGNAL_DETAIL_ORDER_RECORD, {query});
  },
  signalDecreaseBalance(params) {
    return http.post(API_URLS.SIGNAL_DETAIL_DECREASE_BALANCE, {params});
  },
  signalSettingDetail(query) {
    return http.get(API_URLS.SIGNAL_DETAIL_SETTINGS, {query});
  },
  /**合约网格已结利润可提现余额*/
  gridProfitWithdrawable(query: {strategyId: number}) {
    return http.get(API_URLS.STRATEGY_GRID_WITHDRAWABLE, {query});
  },
  /**提现合约网格已结利润*/
  gridProfitWithdraw(params: {strategyId: number; withdrawAmount: string}) {
    return http.post(API_URLS.STRATEGY_GRID_WITHDRAW, {params});
  },
  getAirdropPositions(query = {}) {
    return http.get(API_URLS.STRATEGY_AIR_POS_LIST, {query});
  },
};
